import { Upload } from 'lucide-react';

interface GlobalDropzoneProps {
  isVisible: boolean;
  onDragEnter: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onDragOver: (e: React.DragEvent) => void;
}

export const GlobalDropzone = ({
  isVisible,
  onDragEnter,
  onDragLeave,
  onDrop,
  onDragOver,
}: GlobalDropzoneProps) => {
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onDragOver={onDragOver}
      style={{
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? 'auto' : 'none',
        transition: 'opacity 0.3s ease-in-out',
      }}
    >
      <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-primary bg-white/95 p-12 text-center shadow-2xl dark:bg-gray-900/95">
        <div className="mb-6 flex space-x-4">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Upload className="h-8 w-8 text-primary" />
          </div>
        </div>

        <h2 className="mb-4 text-2xl font-bold text-gray-900 dark:text-white">
          Déposez vos fichiers ou liens PDF ici
        </h2>

        <p className="mb-6 max-w-md text-gray-600 dark:text-gray-300">
          Glissez-déposez vos fichiers PDF/images ou des liens PDF pour les
          analyser
        </p>
        <div className="mt-2 flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
          <span>Taille maximale :</span>
          <span className="rounded px-2 py-1 dark:bg-gray-800">10 MB</span>
        </div>
      </div>
    </div>
  );
};
